import { render, staticRenderFns } from "./CollectionsList.vue?vue&type=template&id=09c2ab58"
import script from "./CollectionsList.vue?vue&type=script&lang=js"
export * from "./CollectionsList.vue?vue&type=script&lang=js"
import style0 from "./CollectionsList.vue?vue&type=style&index=0&id=09c2ab58&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports